// extracted by mini-css-extract-plugin
module.exports = {"title":"Description_style_title__3iWcH","img":"Description_style_img__1XRvh"};